import React, {useState, useEffect, useContext, useRef} from "react";
import {functions} from "../../constants/common-functions";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import AmChartSimpleColumn from "../../components/AmChartSimpleColumn";
import {COLOR_UTILISATION_OCCUPIED} from "../../constants/colors";
import {utilityDashboardComponentContainer} from "../../constants/styles";
import UtilityDashboardLayout from "../../components/dashboardlayouts/UtilityDashboardLayout";
import ChartCardLarge from "../../components/ChartCardLarge";
import {store} from '../../context/store';

export default function UtilisationOccupancyInUse(){
	
	const [data1, setData1] = useState([]);
	const [loaded, setLoaded] = useState(false);
	
	const globalState = useContext(store);
			
	const queryContext =
					    globalState?.state?.queryContext;

	
	useEffect(() => {
		if(loaded === false){
			setLoaded(true);
		}
		loadData();
		
		
	}, [queryContext]);
	
	const loadData = () => {
		loadData1();
	
	};
	
	const loadData1 = () => {
		functions.postFilterBeanAjax(
			"/resolutionsoftwareplatform/dashboard/utilisation/filter/occupancyinuse",
			functions.buildPostBodyFilterBeanQueryContext({}, queryContext),
			handleData1
		);
		
	};
	
	
	const handleData1 = (obj) => {
		console.log(obj);
		
		if(obj.results){
			 const tempData = obj.results.map(({groupBy, returnDouble}) => ({
		    id:groupBy,
		    label:groupBy,
		    value: returnDouble,
		  }));
	  
	  	setData1(tempData);
		}
	 
	};
 	
	
	const refreshFunction = () => {
		loadData();
	};
 	
	return (
		<UtilityDashboardLayout
			    title="Occupancy When In Use"
			    childDashboards={childDashboardsUtilisation}
			    refreshFunction={refreshFunction}
			  >
			  <div style={utilityDashboardComponentContainer}>
	  			  <ChartCardLarge title="Number Of Observations With n People">
				  <AmChartSimpleColumn
					 	chartId="utilisationoccupancyinuse"
					 	chartData={data1}
					 	categoryKey="label"
					 	valueKey="value"
					 	color={COLOR_UTILISATION_OCCUPIED}
					 	width="100%"
					 	height="calc(100% - 30px)"
						/>
	  	  		  </ChartCardLarge>
	  		</div>	  
		</UtilityDashboardLayout>
	);
}